module.exports = __webpack_public_path__ + "static/media/tuja.dbbe889e.jpg";